import * as React from "react";
const SvgFiRrArrowUpToDottedLine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M5 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0m9 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M2 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m20 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3.879 4.879c-1.133-1.134-3.123-1.12-4.229-.014L5.306 9.279a1 1 0 1 0 1.387 1.441L11 6.575V23a1 1 0 0 0 2 0V6.575l4.307 4.145a.998.998 0 0 0 1.414-.028 1 1 0 0 0-.027-1.414z"
    />
  </svg>
);
export default SvgFiRrArrowUpToDottedLine;
